import { Component, OnInit, HostListener } from '@angular/core';
import { ConfirmComponent } from '../confirm/confirm.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/services/http/http.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { PlatformLocation } from '@angular/common';
import { LocalstorageService } from 'src/app/services/localstorage/localstorage.service';
import { UtilityServicesService } from 'src/app/services/utility-service/utility-services.service';
import { InstructionComponent } from '../instruction/instruction.component';
import { MoreInfoComponent } from '../more-info/more-info.component';
import { UserServicesService } from 'src/app/services/user-service/user-services.service';

@Component({
  selector: 'app-redirect-from-bridgelabz',
  templateUrl: './redirect-from-bridgelabz.component.html',
  styleUrls: ['./redirect-from-bridgelabz.component.scss']
})
export class RedirectFromBridgelabzComponent implements OnInit {
  timetest: any;
  actualExamTime: any = 600;
  timeLeft: any = 600;
  interval;
  time = "00:00";
  questionList = [];
  currentIndex = 0;
  //backPressed = false;
  totalTime = "00";
  elapsesTime;
  startTime;
  stopTime;
  showError = false;
  errorMsg = "";
  startTestTime;
  stopTestTime;
  isRefreshClicked = false;
  isOpenDialog = false;
  percentage: any = 0;
  score: string;
  resultTemplateUrl: any;
  maxAttemptCount: any;
  screenWidth:any;
  check:any;
  campaignShortName:string;
  interviewMessage = "";
  interviewAddress = "";
  referralType = "";
  displayFlag: boolean = false;
  isHiringDrive: boolean = false;
  campPurpose: any;
  testtime:any;
  constructor(
    private localstorageService: LocalstorageService,
    private utilityServices: UtilityServicesService,
    private  route: ActivatedRoute,
    private userServices: UserServicesService,
    private router:Router) {

  }

  ngOnInit() {
    this.localstorageService.setData('token',this.route.snapshot.paramMap.get('token'));
    this.localstorageService.setData('CampaignShortName',this.route.snapshot.paramMap.get('campaignShortName'));
    this.localstorageService.setData('userName',this.route.snapshot.paramMap.get('userName'));
    this.localstorageService.setData('fromUrl',true)
    this.localstorageService.setData('per',50)
  
    
  }
  startTest(){
    this.localstorageService.setData("examStarted", "1");
      this.localstorageService.setData("startTestTime", this.startTestTime);
    this.router.navigate(['/test']);
  }



}
